/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Macos_S1Inputs */

const en_fc_dl_macos_s1 = /** @type {(inputs: Fc_Dl_Macos_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the Universal DMG.`)
};

/**
* | output |
* | --- |
* | "Download the Universal DMG." |
*
* @param {Fc_Dl_Macos_S1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_macos_s1 = /** @type {((inputs?: Fc_Dl_Macos_S1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Macos_S1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_macos_s1(inputs)
});
export { fc_dl_macos_s1 as "fc.dl.macos.s1" }